export default "__VITE_ASSET__HMIfqQjD__"